import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { VersionToggleService } from '../services/version-toggle.service';

export const v1MatchGuard: CanMatchFn = () => {
  const versionService = inject(VersionToggleService);
  return !versionService.isV2;
};

export const v2MatchGuard: CanMatchFn = () => {
  const versionService = inject(VersionToggleService);
  return versionService.isV2;
};
